module.exports = "<div class=\"modal-header\">\r\n    <h4 class=\"modal-title mt-0\">{{'texto.sesionFinalizadaLabel' | translate}}</h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n    <p>{{'texto.laSesionHaTerminado' | translate}}, <strong> {{'texto.iniciaSesionNuevamente' | translate}}.</strong></p>\r\n</div>\r\n<div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-primary  btn-sm\" (click)=\"closeModal(x)\">{{'texto.aceptarLabel' | translate}}</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logout/logout.component.html
// module id = ./src/app/components/logout/logout.component.html
// module chunks = main